import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

const Avatar = ({ 
  src, 
  name, 
  size = 'md', 
  className,
  showDecoration = true,
  type = 'user' // user, agency, client, creative
}) => {
  const { getSeasonalDecoration, theme } = useTheme();
  const decoration = showDecoration ? getSeasonalDecoration() : null;
  
  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl',
    '2xl': 'w-20 h-20 text-2xl',
  };

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'agency':
        return 'bg-[var(--color-primary)]';
      case 'client':
        return 'bg-[var(--color-accent)]';
      case 'creative':
        return 'bg-[#6366f1]';
      default:
        return 'bg-[var(--color-primary)]/20';
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'agency':
      case 'creative':
        return 'text-white';
      case 'client':
        return 'text-[var(--color-primary)]';
      default:
        return 'text-[var(--color-primary)]';
    }
  };

  return (
    <div className={cn("relative inline-block", className)}>
      {/* Main avatar */}
      <div
        className={cn(
          "rounded-full overflow-hidden flex items-center justify-center font-semibold",
          sizeClasses[size],
          !src && getBackgroundColor(),
          !src && getTextColor()
        )}
        data-testid="avatar"
      >
        {src ? (
          <img 
            src={src} 
            alt={name || 'Avatar'} 
            className="w-full h-full object-cover"
          />
        ) : (
          <span>{getInitials(name)}</span>
        )}
      </div>
      
      {/* Seasonal decoration */}
      {decoration && (
        <div 
          className={cn(
            "absolute -top-1 -right-1 text-sm pointer-events-none",
            decoration.className
          )}
          style={{
            fontSize: size === 'xs' || size === 'sm' ? '0.75rem' : 
                     size === 'md' ? '0.875rem' : 
                     size === 'lg' ? '1rem' : '1.25rem'
          }}
        >
          {decoration.overlay}
        </div>
      )}
    </div>
  );
};

export default Avatar;
